// extracted by mini-css-extract-plugin
export default {"container":"SimpleSideNav_container__uDHPM","active":"SimpleSideNav_active__OSpVC"};